import AppLayout from "../layouts/AppLayout";

export default function ErrorPage({ status }) {
    const title = {
        503: 'Service Unavailable',
        500: 'Server Error',
        404: 'Page Not Found',
        403: 'Forbidden',
    }[status]

    const description = {
        503: 'Sorry, we are doing some maintenance. Please check back soon.',
        500: 'Whoops, something went wrong on our servers.',
        404: "The page you're looking for doesn't exist or has been moved.",
        403: 'Sorry, you are forbidden from accessing this page.',
    }[status]

    return (
        <div className="bg-gray-100 flex items-center justify-center h-screen">
            <div className="text-center px-6">
                <h1 className="text-6xl font-bold text-blue-600 mb-4">{status}</h1>
                <p className="text-2xl font-semibold text-gray-800 mb-2">{title}</p>
                <p className="text-gray-600 mb-6">{description}</p>
                <a href="/" className="inline-block px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition">
                    ← Back to Home
                </a>
            </div>
        </div >
    )
}